<div class="create-wrapper">
  <!-- Page Header -->
  <div class="page-header">
    <div class="page-header-icon">
      <nz-icon nzType="plus-circle" nzTheme="outline" />
    </div>
    <div>
      <h2 class="page-header-title">Nowy kod {{ title }}</h2>
      <p class="page-header-subtitle">Wypełnij formularz, aby utworzyć nowy kod</p>
    </div>
  </div>

  <form nz-form nzLayout="vertical" class="create-form">
    <!-- DANE KODU -->
    <nz-card class="form-card" [nzBordered]="false">
      <div class="card-section-header">
        <span nz-icon nzType="file-text" nzTheme="outline" class="section-icon"></span>
        <span>Dane kodu</span>
      </div>

      <div nz-row [nzGutter]="[24, 0]">
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label nzRequired>Kod</nz-form-label>

            <nz-form-control>
              <input
                nz-input
                name="code"
                placeholder="np. A00"
                [ngModel]="model().code"
                (ngModelChange)="model.set({ ...model(), code: $event })"
                required
              />
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label nzRequired>Nazwa</nz-form-label>

            <nz-form-control>
              <input
                nz-input
                name="name"
                placeholder="Nazwa kodu"
                [ngModel]="model().name"
                (ngModelChange)="model.set({ ...model(), name: $event })"
                required
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </nz-card>

    <!-- STATUS -->
    <nz-card class="form-card" [nzBordered]="false">
      <div class="card-section-header">
        <span nz-icon nzType="safety-certificate" nzTheme="outline" class="section-icon"></span>
        <span>Status</span>
      </div>

      <nz-divider nzDashed style="margin: 12px 0"></nz-divider>

      <label
        nz-checkbox
        name="isVerified"
        [ngModel]="model().isVerified"
        (ngModelChange)="model.set({ ...model(), isVerified: $event })"
      >
        Kod zweryfikowany
      </label>
    </nz-card>
  </form>

  <!-- FOOTER -->
  <div class="button-footer-wrapper">
    <a nz-button nzType="default" [routerLink]="['/codes', type.toLowerCase()]">
      <span nz-icon nzType="arrow-left"></span>
      Wstecz
    </a>

    <button
      nz-button
      nzType="primary"
      (click)="submit()"
      [nzLoading]="isSubmitting()"
      [disabled]="isSubmitting() || !model().code.trim() || !model().name.trim()"
    >
      <span nz-icon nzType="save"></span>
      Zapisz kod
    </button>
  </div>
</div>
